var getProductWidth = function () {
    return $('#alsobought-recs .product:first-of-type').width();
};

$(document).ready(function () {
    let current_page = 1;
    let animation = false;

    function moveLeft() {
        if (current_page > 1 && !animation) {
            let leftPos = $('#alsobought-recs').scrollLeft();
            animation = true;
            $("#alsobought-recs").animate({scrollLeft: leftPos - getProductWidth()}, 800, function () {
                animation = false;
            });
            current_page--;
            $.each($('.recommended__paginate--page'), function (key, value) {
                if ($(this).data('page') === current_page) {
                    $('.recommended__paginate--page').attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-dot.svg?v=32662681087428334901601624783');
                    $(this).attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-active.svg?v=145450004874759333581601624819');
                }
            })
        }
    }

    function moveRight() {
        if (current_page < 4 && !animation) {
            let leftPos = $('#alsobought-recs').scrollLeft();
            animation = true;
            $("#alsobought-recs").animate({scrollLeft: leftPos + getProductWidth()}, 800, function () {
                animation = false;
            });
            current_page++;
            $.each($('.recommended__paginate--page'), function (key, value) {
                if ($(this).data('page') === current_page) {
                    $('.recommended__paginate--page').attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-dot.svg?v=32662681087428334901601624783');
                    $(this).attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-active.svg?v=145450004874759333581601624819');
                }
            })
        }
    }

    function moveToPage() {
        let pos = ($(this).data('page') - 1) * getProductWidth();
        $('.recommended__paginate--page').attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-dot.svg?v=32662681087428334901601624783');
        $(this).attr('src', '//baotechusa.com/cdn/shop/t/7/assets/product-recommender-active.svg?v=145450004874759333581601624819');
        $("#alsobought-recs").animate({scrollLeft: pos}, 800);
        current_page = $(this).data('page');
    }

    $('.recommended__paginate--left').on('click touch', moveLeft);
    $('.recommended__paginate--right').on('click touch', moveRight);
    $('.recommended__paginate--page').on('click touch', moveToPage);

    var $alsobought_recs = document.getElementById('alsobought-recs');

    if ($alsobought_recs) {
        var hammer_element = new Hammer($alsobought_recs);

        hammer_element.on('swipeleft', moveRight);
        hammer_element.on('swiperight', moveLeft);
    }
})